// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/atlas/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getHealthReadiness: build.query<GetHealthReadinessApiResponse, GetHealthReadinessApiArg>({
            query: () => ({ url: `/health/readiness` }),
        }),
        getHealthLiveness: build.query<GetHealthLivenessApiResponse, GetHealthLivenessApiArg>({
            query: () => ({ url: `/health/liveness` }),
        }),
        createSavedQuestion: build.mutation<CreateSavedQuestionApiResponse, CreateSavedQuestionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/questions`,
                method: "POST",
                body: queryArg.createSavedQuestionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listSavedQuestions: build.query<ListSavedQuestionsApiResponse, ListSavedQuestionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/questions`,
                params: { page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteSavedQuestion: build.mutation<DeleteSavedQuestionApiResponse, DeleteSavedQuestionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/questions/${queryArg.savedQuestionId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSavedQuestionById: build.query<GetSavedQuestionByIdApiResponse, GetSavedQuestionByIdApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/questions/${queryArg.savedQuestionId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateSavedQuestion: build.mutation<UpdateSavedQuestionApiResponse, UpdateSavedQuestionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/questions/${queryArg.savedQuestionId}`,
                method: "PATCH",
                body: queryArg.patchSavedQuestionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createQuestionGroup: build.mutation<CreateQuestionGroupApiResponse, CreateQuestionGroupApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/question-groups`,
                method: "POST",
                body: queryArg.createQuestionGroupRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listQuestionGroups: build.query<ListQuestionGroupsApiResponse, ListQuestionGroupsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/question-groups`,
                params: { page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteQuestionGroup: build.mutation<DeleteQuestionGroupApiResponse, DeleteQuestionGroupApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/question-groups/${queryArg.questionGroupId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getQuestionGroupById: build.query<GetQuestionGroupByIdApiResponse, GetQuestionGroupByIdApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/question-groups/${queryArg.questionGroupId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateQuestionGroup: build.mutation<UpdateQuestionGroupApiResponse, UpdateQuestionGroupApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/question-groups/${queryArg.questionGroupId}`,
                method: "PATCH",
                body: queryArg.patchQuestionGroupRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listQuestionsByQuestionGroupId: build.query<ListQuestionsByQuestionGroupIdApiResponse, ListQuestionsByQuestionGroupIdApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/question-groups/${queryArg.questionGroupId}/questions`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createGuideline: build.mutation<CreateGuidelineApiResponse, CreateGuidelineApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/guidelines`,
                method: "POST",
                body: queryArg.createGuidelineRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listGuidelines: build.query<ListGuidelinesApiResponse, ListGuidelinesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/guidelines`,
                params: {
                    search: queryArg.search,
                    sort: queryArg.sort,
                    risk: queryArg.risk,
                    last_modified: queryArg.lastModified,
                    access: queryArg.access,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getGuidelineById: build.query<GetGuidelineByIdApiResponse, GetGuidelineByIdApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/guidelines/${queryArg.guidelineId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateGuideline: build.mutation<UpdateGuidelineApiResponse, UpdateGuidelineApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/guidelines/${queryArg.guidelineId}`,
                method: "PATCH",
                body: queryArg.updateGuidelineRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteGuideline: build.mutation<DeleteGuidelineApiResponse, DeleteGuidelineApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/guidelines/${queryArg.guidelineId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getGuidelinePlaybooks: build.query<GetGuidelinePlaybooksApiResponse, GetGuidelinePlaybooksApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/guidelines/${queryArg.guidelineId}/playbooks`,
                params: { page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createPlaybook: build.mutation<CreatePlaybookApiResponse, CreatePlaybookApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks`,
                method: "POST",
                body: queryArg.createPlaybookRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listPlaybooks: build.query<ListPlaybooksApiResponse, ListPlaybooksApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks`,
                params: {
                    search: queryArg.search,
                    workflow_id: queryArg.workflowId,
                    status: queryArg.status,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listPlaybookTemplates: build.query<ListPlaybookTemplatesApiResponse, ListPlaybookTemplatesApiArg>({
            query: () => ({ url: `/api/v1/playbooks/templates` }),
        }),
        getPlaybookTemplateById: build.query<GetPlaybookTemplateByIdApiResponse, GetPlaybookTemplateByIdApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/templates/${queryArg.templateId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPlaybookList: build.query<GetPlaybookListApiResponse, GetPlaybookListApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/list`,
                params: {
                    name: queryArg.name,
                    last_modified: queryArg.lastModified,
                    status: queryArg.status,
                    workflow_id: queryArg.workflowId,
                    access: queryArg.access,
                    restriction: Array.isArray(queryArg.restriction) ? queryArg.restriction.join(",") : queryArg.restriction,
                    fields: queryArg.fields,
                    sort: queryArg.sort,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        validateImportPlaybook: build.mutation<ValidateImportPlaybookApiResponse, ValidateImportPlaybookApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/import/validate`,
                method: "POST",
                body: queryArg.validatePlaybookRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postPlaybookAnalytics: build.mutation<PostPlaybookAnalyticsApiResponse, PostPlaybookAnalyticsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/analytics`,
                method: "POST",
                body: queryArg.playbookUsageAnalyticsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPlaybookAnalyticsById: build.query<GetPlaybookAnalyticsByIdApiResponse, GetPlaybookAnalyticsByIdApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/${queryArg.playbookId}/analytics`,
                params: { most_negotiated: queryArg.mostNegotiated },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPlaybookById: build.query<GetPlaybookByIdApiResponse, GetPlaybookByIdApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/${queryArg.playbookId}`,
                params: {
                    "clause-acl": queryArg["clause-acl"],
                    "guideline-acl": queryArg["guideline-acl"],
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updatePlaybook: build.mutation<UpdatePlaybookApiResponse, UpdatePlaybookApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/${queryArg.playbookId}`,
                method: "PATCH",
                body: queryArg.updatePlaybookRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deletePlaybook: build.mutation<DeletePlaybookApiResponse, DeletePlaybookApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/${queryArg.playbookId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        exportPlaybook: build.mutation<ExportPlaybookApiResponse, ExportPlaybookApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/${queryArg.playbookId}/export`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPlaybookAccess: build.query<GetPlaybookAccessApiResponse, GetPlaybookAccessApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/${queryArg.playbookId}/access`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        setPlaybookAccess: build.mutation<SetPlaybookAccessApiResponse, SetPlaybookAccessApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/playbooks/${queryArg.playbookId}/access`,
                method: "PUT",
                body: queryArg.playbookAccessAttributesInput,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetHealthReadinessApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type GetHealthReadinessApiArg = void;
export type GetHealthLivenessApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type GetHealthLivenessApiArg = void;
export type CreateSavedQuestionApiResponse = 
/** status 201 Successful Response */ CreateSavedQuestionResponse;
export type CreateSavedQuestionApiArg = {
    createSavedQuestionRequest: CreateSavedQuestionRequest;
};
export type ListSavedQuestionsApiResponse = 
/** status 200 Successful Response */ GetSavedQuestionPageResponse;
export type ListSavedQuestionsApiArg = {
    page?: {
        offset?: number;
        limit?: number;
    };
};
export type DeleteSavedQuestionApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteSavedQuestionApiArg = {
    savedQuestionId: string;
};
export type GetSavedQuestionByIdApiResponse = 
/** status 200 Successful Response */ GetSavedQuestionResponse;
export type GetSavedQuestionByIdApiArg = {
    savedQuestionId: string;
};
export type UpdateSavedQuestionApiResponse = 
/** status 200 Successful Response */ PatchSavedQuestionResponse;
export type UpdateSavedQuestionApiArg = {
    savedQuestionId: string;
    patchSavedQuestionRequest: PatchSavedQuestionRequest;
};
export type CreateQuestionGroupApiResponse = 
/** status 201 Successful Response */ CreateQuestionGroupResponse;
export type CreateQuestionGroupApiArg = {
    createQuestionGroupRequest: CreateQuestionGroupRequest;
};
export type ListQuestionGroupsApiResponse = 
/** status 200 Successful Response */ GetQuestionGroupPageResponse;
export type ListQuestionGroupsApiArg = {
    page?: {
        offset?: number;
        limit?: number;
    };
};
export type DeleteQuestionGroupApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteQuestionGroupApiArg = {
    questionGroupId: string;
};
export type GetQuestionGroupByIdApiResponse = 
/** status 200 Successful Response */ GetQuestionGroupResponse;
export type GetQuestionGroupByIdApiArg = {
    questionGroupId: string;
};
export type UpdateQuestionGroupApiResponse = 
/** status 200 Successful Response */ PatchQuestionGroupResponse;
export type UpdateQuestionGroupApiArg = {
    questionGroupId: string;
    patchQuestionGroupRequest: PatchQuestionGroupRequest;
};
export type ListQuestionsByQuestionGroupIdApiResponse = 
/** status 200 Successful Response */ GetQuestionGroupSavedQuestionsResponse;
export type ListQuestionsByQuestionGroupIdApiArg = {
    questionGroupId: string;
};
export type CreateGuidelineApiResponse = 
/** status 201 Successful Response */ CreateGuidelineResponse;
export type CreateGuidelineApiArg = {
    createGuidelineRequest: CreateGuidelineRequest;
};
export type ListGuidelinesApiResponse = 
/** status 200 Successful Response */ ListGuidelinesResponse;
export type ListGuidelinesApiArg = {
    /** Filter guidelines by name. */
    search?: string;
    /** Sort field; prefix with '-' for descending. Allowed: name, risk, created_at, updated_at, playbook_count. 'risk' orders by severity, not by label. 'playbook_count' orders by the same published-plus-own-drafts count returned on each guideline. */
    sort?: string;
    /** Filter guidelines to a single risk level. */
    risk?: "Critical" | "High" | "Medium" | "Low" | "None";
    /** Filter guidelines by how recently they were last modified. */
    lastModified?: "new" | "one_to_three_weeks" | "over_three_weeks";
    /** With playbook ACLs on, return only guidelines the caller can use. Ignored otherwise. */
    access?: "use";
    page?: {
        offset?: number;
        limit?: number;
    };
};
export type GetGuidelineByIdApiResponse = 
/** status 200 Successful Response */ GetGuidelineResponse;
export type GetGuidelineByIdApiArg = {
    guidelineId: string;
};
export type UpdateGuidelineApiResponse = 
/** status 200 Successful Response */ UpdateGuidelineResponse;
export type UpdateGuidelineApiArg = {
    guidelineId: string;
    updateGuidelineRequest: UpdateGuidelineRequest;
};
export type DeleteGuidelineApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteGuidelineApiArg = {
    guidelineId: string;
};
export type GetGuidelinePlaybooksApiResponse = 
/** status 200 Successful Response */ ListGuidelinePlaybooksResponse;
export type GetGuidelinePlaybooksApiArg = {
    guidelineId: string;
    page?: {
        offset?: number;
        limit?: number;
    };
};
export type CreatePlaybookApiResponse = 
/** status 201 Successful Response */ CreatePlaybookResponse;
export type CreatePlaybookApiArg = {
    createPlaybookRequest: CreatePlaybookRequest;
};
export type ListPlaybooksApiResponse = 
/** status 200 Successful Response */ ListPlaybooksResponse;
export type ListPlaybooksApiArg = {
    search?: string | null;
    workflowId?: string | null;
    /** Filter playbooks by status (DRAFT or PUBLISHED). */
    status?: PlaybookStatus | null;
    page?: {
        offset?: number;
        limit?: number;
    };
};
export type ListPlaybookTemplatesApiResponse = 
/** status 200 Successful Response */ ListPlaybookTemplatesResponse;
export type ListPlaybookTemplatesApiArg = void;
export type GetPlaybookTemplateByIdApiResponse = 
/** status 200 Successful Response */ GetPlaybookTemplateResponse;
export type GetPlaybookTemplateByIdApiArg = {
    templateId: string;
};
export type GetPlaybookListApiResponse = 
/** status 200 Successful Response */ ListPlaybooksWithAnalyticsResponse;
export type GetPlaybookListApiArg = {
    /** Filter playbooks by name (substring match). */
    name?: string;
    /** Filter playbooks by how recently they were last modified. */
    lastModified?: "new" | "one_to_three_weeks" | "over_three_weeks";
    /** Filter playbooks by status (DRAFT or PUBLISHED). */
    status?: "DRAFT" | "PUBLISHED";
    /** Filter playbooks by workflow ID. */
    workflowId?: string;
    /** Narrow results to playbooks where the caller holds at least this access tier (`use` or `edit`). No-op when `Flag.PLAYBOOK_ACL` is off. */
    access?: "use" | "edit";
    /** Comma-separated restriction states to include: `none` (not restricted), `accessible` (caller can use it, restricted or shared with everyone), `restricted` (restricted, caller can't use it). A playbook matching any listed state is returned. No-op when `Flag.PLAYBOOK_ACL` is off. */
    restriction?: ("none" | "accessible" | "restricted")[];
    /** Comma-separated playbook fields to include. Omit to include all fields including analytics. `uuid` is always included. */
    fields?: string;
    /** Sort field; prefix with '-' for descending. Allowed: name, status, created_at, updated_at, created_by, updated_by, total_completed_reviews_count, last_run_at. */
    sort?: string;
    page?: {
        offset?: number;
        limit?: number;
    };
};
export type ValidateImportPlaybookApiResponse = 
/** status 200 Successful Response */ ValidateImportPlaybookResponse;
export type ValidateImportPlaybookApiArg = {
    validatePlaybookRequest: ValidatePlaybookRequest;
};
export type PostPlaybookAnalyticsApiResponse = 
/** status 200 Successful Response */ PlaybookUsageAnalyticsResponse;
export type PostPlaybookAnalyticsApiArg = {
    playbookUsageAnalyticsRequest: PlaybookUsageAnalyticsRequest;
};
export type GetPlaybookAnalyticsByIdApiResponse = 
/** status 200 Successful Response */ PlaybookDetailAnalyticsResponse;
export type GetPlaybookAnalyticsByIdApiArg = {
    playbookId: string;
    mostNegotiated?: {
        /** Page size for most_negotiated_requirements only; 0 returns all after offset. recent_uses ignores this. */
        page?: number;
    };
};
export type GetPlaybookByIdApiResponse = 
/** status 200 Successful Response */ GetPlaybookResponse;
export type GetPlaybookByIdApiArg = {
    playbookId: string;
    /** Annotate library clause variations with is_open. Opt-in so callers that don't need it (e.g. AI review) skip the SpiceDB check. */
    "clause-acl"?: boolean;
    /** Annotate guidelines with is_restricted. Opt-in so callers that don't need it (e.g. AI review) skip the SpiceDB check. */
    "guideline-acl"?: boolean;
};
export type UpdatePlaybookApiResponse = 
/** status 200 Successful Response */ UpdatePlaybookResponse;
export type UpdatePlaybookApiArg = {
    playbookId: string;
    updatePlaybookRequest: UpdatePlaybookRequest;
};
export type DeletePlaybookApiResponse = 
/** status 204 Successful Response */ void;
export type DeletePlaybookApiArg = {
    playbookId: string;
};
export type ExportPlaybookApiResponse = 
/** status 200 Successful Response */ ExportPlaybookResponse;
export type ExportPlaybookApiArg = {
    playbookId: string;
};
export type GetPlaybookAccessApiResponse = 
/** status 200 Successful Response */ PlaybookAccessAttributes;
export type GetPlaybookAccessApiArg = {
    playbookId: string;
};
export type SetPlaybookAccessApiResponse = 
/** status 200 Successful Response */ SetPlaybookAccessResponse;
export type SetPlaybookAccessApiArg = {
    playbookId: string;
    playbookAccessAttributesInput: PlaybookAccessAttributes2;
};
export type CheckResult = {
    name: string;
    passed: boolean;
    details?: string | null;
};
export type HealthcheckReport = {
    healthy: boolean;
    checks: CheckResult[];
};
export type SavedQuestion = {
    name?: string | null;
    text?: string | null;
    created_at?: string | null;
    pinned_at?: string | null;
    updated_at?: string | null;
    scope?: string | null;
    pilot_user_id?: number | null;
    question_group_ids?: string[] | null;
};
export type CreateSavedQuestionResponseData = {
    type?: string;
    id: string;
    attributes: SavedQuestion;
};
export type CreateSavedQuestionResponse = {
    data: CreateSavedQuestionResponseData;
};
export type ErrorData = {
    code: string;
    detail: string;
    status: string;
    title: string;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ErrorResponse = {
    errors: ErrorData[];
};
export type CreateSavedQuestionRequestData = {
    type?: string;
    attributes: SavedQuestion;
};
export type CreateSavedQuestionRequest = {
    data: CreateSavedQuestionRequestData;
};
export type GetSavedQuestionResponseData = {
    type?: string;
    id: string;
    attributes: SavedQuestion;
};
export type SavedQuestionPageMeta = {
    offset: number;
    limit: number;
    count: number;
    total: number;
    scope?: string | null;
    search?: string | null;
};
export type PageLinks = {
    first: string;
    last?: string | null;
    prev?: string | null;
    next?: string | null;
};
export type GetSavedQuestionPageResponse = {
    data: GetSavedQuestionResponseData[];
    meta: SavedQuestionPageMeta;
    links: PageLinks;
};
export type GetSavedQuestionResponse = {
    data: GetSavedQuestionResponseData;
};
export type PatchSavedQuestionResponseData = {
    type?: string;
    id: string;
    attributes: SavedQuestion;
};
export type PatchSavedQuestionResponse = {
    data: PatchSavedQuestionResponseData;
};
export type PatchSavedQuestionRequestData = {
    type?: string;
    attributes: SavedQuestion;
};
export type PatchSavedQuestionRequest = {
    data: PatchSavedQuestionRequestData;
};
export type SharingVisibility = "OPEN" | "PRIVATE" | "SHARED";
export type QuestionGroup = {
    name?: string | null;
    description?: string | null;
    created_at?: string | null;
    pinned_at?: string | null;
    updated_at?: string | null;
    pilot_user_id?: number | null;
    pilot_client_id?: number | null;
    updated_by_user_id?: number | null;
    question_ids?: string[] | null;
    visibility?: SharingVisibility;
    user_ids?: number[] | null;
    department_ids?: number[] | null;
};
export type CreateQuestionGroupResponseData = {
    type?: string;
    id: string;
    attributes: QuestionGroup;
};
export type CreateQuestionGroupResponse = {
    data: CreateQuestionGroupResponseData;
};
export type CreateQuestionGroupRequestData = {
    type?: string;
    attributes: QuestionGroup;
};
export type CreateQuestionGroupRequest = {
    data: CreateQuestionGroupRequestData;
};
export type GetQuestionGroupResponseData = {
    type?: string;
    id: string;
    attributes: QuestionGroup;
};
export type QuestionGroupPageMeta = {
    offset: number;
    limit: number;
    count: number;
    total: number;
    search?: string | null;
    visibility?: string | null;
};
export type GetQuestionGroupPageResponse = {
    data: GetQuestionGroupResponseData[];
    meta: QuestionGroupPageMeta;
    links: PageLinks;
};
export type GetQuestionGroupResponse = {
    data: GetQuestionGroupResponseData;
};
export type PatchQuestionGroupResponseData = {
    type?: string;
    id: string;
    attributes: QuestionGroup;
};
export type PatchQuestionGroupResponse = {
    data: PatchQuestionGroupResponseData;
};
export type PatchQuestionGroupRequestData = {
    type?: string;
    attributes: QuestionGroup;
};
export type PatchQuestionGroupRequest = {
    data: PatchQuestionGroupRequestData;
};
export type GetQuestionGroupSavedQuestionsResponse = {
    data: GetSavedQuestionResponseData[];
};
export type PositionType = "Preferred" | "Fallback" | "Walk away";
export type GuidelineClauseVariation = {
    id?: string | null;
    clause_variation_id?: string | null;
    name: string;
    text?: string | null;
    position: PositionType;
    guidance?: string | null;
    /** Whether this Clause Library variation is open to the whole tenant. Unset for local variations, and whenever Flag.PLAYBOOK_ACL is off or the check failed. */
    is_open?: boolean | null;
};
export type RiskLevel = "Critical" | "High" | "Medium" | "Low" | "None";
export type CitationRect = {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    pageNumber: number;
    width: number;
    height: number;
    pageRotation?: number | null;
};
export type CitationCoordinate = {
    page_number: number;
    rects: CitationRect[];
};
export type Citation = {
    id: string;
    text: string;
    source?: string | null;
    source_object_id?: string[] | null;
    coordinates?: CitationCoordinate[] | null;
};
export type GuidelineRule = {
    id: string;
    rule_text?: string | null;
    rule_type?: string | null;
    priority?: string | null;
    prohibited_terms?: string[] | null;
    not_actionable?: boolean | null;
    concerns?: string | null;
    /** The author saved anyway despite this rule's concern. */
    concern_accepted?: boolean;
};
export type GuidelineWithId = {
    /** UUID for referencing existing guideline or preset UUID for new guideline */
    id?: string | null;
    name: string;
    /** Rich text string for guideline text */
    guideline?: string;
    /** Rich text string for sample language */
    sample?: string;
    variations?: GuidelineClauseVariation[];
    suggest_redlines?: boolean;
    /** Admin-configured risk level override. When unset, AI determines risk at runtime. */
    risk?: RiskLevel | null;
    /** AI-generated provenance for this guideline. Static — captured at generation time and not updated when the guideline is edited. Excluded from playbook exports. */
    citations?: Citation[] | null;
    /** Null means never extracted, which is not the same as an empty list. */
    rules?: GuidelineRule[] | null;
    created_at?: string | null;
    updated_at?: string | null;
    /** ID of the user who created this guideline. */
    created_by_pilot_user_id?: number | null;
    /** ID of the user who last updated this guideline. */
    updated_by_pilot_user_id?: number | null;
    uuid: string;
};
export type CreateGuidelineResponseData = {
    type?: string;
    id: string;
    attributes: GuidelineWithId;
};
export type CreateGuidelineResponse = {
    data: CreateGuidelineResponseData;
};
export type Citation2 = {
    id: string;
    text: string;
    source?: string | null;
    source_object_id?: string[] | null;
    coordinates?: CitationCoordinate[] | null;
};
export type Guideline = {
    /** UUID for referencing existing guideline or preset UUID for new guideline */
    id?: string | null;
    name: string;
    /** Rich text string for guideline text */
    guideline?: string;
    /** Rich text string for sample language */
    sample?: string;
    variations?: GuidelineClauseVariation[];
    suggest_redlines?: boolean;
    /** Admin-configured risk level override. When unset, AI determines risk at runtime. */
    risk?: RiskLevel | null;
    /** AI-generated provenance for this guideline. Static — captured at generation time and not updated when the guideline is edited. Excluded from playbook exports. */
    citations?: Citation2[] | null;
    /** Null means never extracted, which is not the same as an empty list. */
    rules?: GuidelineRule[] | null;
    created_at?: string | null;
    updated_at?: string | null;
    /** ID of the user who created this guideline. */
    created_by_pilot_user_id?: number | null;
    /** ID of the user who last updated this guideline. */
    updated_by_pilot_user_id?: number | null;
};
export type CreateGuidelineRequestData = {
    type?: string;
    attributes: Guideline;
};
export type CreateGuidelineRequest = {
    data: CreateGuidelineRequestData;
};
export type GuidelineWithUsage = {
    /** UUID for referencing existing guideline or preset UUID for new guideline */
    id?: string | null;
    name: string;
    /** Rich text string for guideline text */
    guideline?: string;
    /** Rich text string for sample language */
    sample?: string;
    variations?: GuidelineClauseVariation[];
    suggest_redlines?: boolean;
    /** Admin-configured risk level override. When unset, AI determines risk at runtime. */
    risk?: RiskLevel | null;
    /** AI-generated provenance for this guideline. Static — captured at generation time and not updated when the guideline is edited. Excluded from playbook exports. */
    citations?: Citation[] | null;
    /** Null means never extracted, which is not the same as an empty list. */
    rules?: GuidelineRule[] | null;
    created_at?: string | null;
    updated_at?: string | null;
    /** ID of the user who created this guideline. */
    created_by_pilot_user_id?: number | null;
    /** ID of the user who last updated this guideline. */
    updated_by_pilot_user_id?: number | null;
    uuid: string;
    playbook_count?: number;
    can_use?: boolean | null;
    is_open?: boolean | null;
};
export type ListGuidelineResponseData = {
    type?: string;
    id: string;
    attributes: GuidelineWithUsage;
};
export type PlaybookLastModifiedBucket = "new" | "one_to_three_weeks" | "over_three_weeks";
export type PlaybookAccessLevel = "use" | "edit";
export type GuidelinePageMeta = {
    offset: number;
    limit: number;
    count: number;
    total: number;
    search?: string | null;
    sort?: string | null;
    risk?: RiskLevel | null;
    last_modified?: PlaybookLastModifiedBucket | null;
    access?: PlaybookAccessLevel | null;
};
export type ListGuidelinesResponse = {
    data: ListGuidelineResponseData[];
    meta: GuidelinePageMeta;
    links: PageLinks;
};
export type GuidelineWithAccess = {
    /** UUID for referencing existing guideline or preset UUID for new guideline */
    id?: string | null;
    name: string;
    /** Rich text string for guideline text */
    guideline?: string;
    /** Rich text string for sample language */
    sample?: string;
    variations?: GuidelineClauseVariation[];
    suggest_redlines?: boolean;
    /** Admin-configured risk level override. When unset, AI determines risk at runtime. */
    risk?: RiskLevel | null;
    /** AI-generated provenance for this guideline. Static — captured at generation time and not updated when the guideline is edited. Excluded from playbook exports. */
    citations?: Citation[] | null;
    /** Null means never extracted, which is not the same as an empty list. */
    rules?: GuidelineRule[] | null;
    created_at?: string | null;
    updated_at?: string | null;
    /** ID of the user who created this guideline. */
    created_by_pilot_user_id?: number | null;
    /** ID of the user who last updated this guideline. */
    updated_by_pilot_user_id?: number | null;
    uuid: string;
    can_edit?: boolean | null;
};
export type GetGuidelineResponseData = {
    type?: string;
    id: string;
    attributes: GuidelineWithAccess;
};
export type ClauseAclStatus = {
    complete: boolean;
};
export type ClauseAclMeta = {
    clause_acl: ClauseAclStatus;
};
export type GetGuidelineResponse = {
    data: GetGuidelineResponseData;
    meta?: ClauseAclMeta | null;
};
export type UpdateGuidelineResponseData = {
    type?: string;
    id: string;
    attributes: GuidelineWithId;
};
export type UpdateGuidelineResponse = {
    data: UpdateGuidelineResponseData;
};
export type UpdateGuidelineRequestData = {
    type?: string;
    attributes: Guideline;
};
export type UpdateGuidelineRequest = {
    data: UpdateGuidelineRequestData;
};
export type GuidelinePlaybookUsage = {
    playbook_id: string;
    playbook_name: string;
    status: "DRAFT" | "PUBLISHED";
    added_to_playbook_at: string;
    created_at: string;
    created_by_pilot_user_id: number;
    updated_at: string;
    updated_by_pilot_user_id: number;
    can_use?: boolean | null;
    can_edit?: boolean | null;
    is_restricted?: boolean | null;
};
export type GuidelinePlaybookResponseData = {
    type?: string;
    id: string;
    attributes: GuidelinePlaybookUsage;
};
export type PageMeta = {
    offset: number;
    limit: number;
    count: number;
    total: number;
};
export type ListGuidelinePlaybooksResponse = {
    data: GuidelinePlaybookResponseData[];
    meta: PageMeta;
    links: PageLinks;
};
export type PlaybookRestrictions = {
    workflow_ids?: string[];
    contract_types?: string[];
};
export type PlaybookStatus = "DRAFT" | "PUBLISHED";
export type PlaybookConflict = {
    id: string;
    conflict_ids: ({
        [key: string]: string;
    } | string)[];
    merged_text?: string | null;
    requirement_name?: string | null;
    has_conflicts?: boolean | null;
    concerns?: string | null;
    accepted?: boolean;
};
export type PlaybookWithId = {
    name?: string;
    description?: string;
    restrictions?: PlaybookRestrictions | null;
    status?: PlaybookStatus;
    created_by_pilot_user_id?: number | null;
    updated_by_pilot_user_id?: number | null;
    created_at?: string | null;
    updated_at?: string | null;
    uuid: string;
    guidelines?: GuidelineWithId[];
    /** Null means never checked, which is not the same as an empty list. */
    conflicts?: PlaybookConflict[] | null;
};
export type CreatePlaybookResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookWithId;
};
export type CreatePlaybookResponse = {
    data: CreatePlaybookResponseData;
};
export type Playbook = {
    name: string;
    description: string;
    restrictions?: PlaybookRestrictions | null;
    status?: PlaybookStatus;
    created_by_pilot_user_id?: number | null;
    updated_by_pilot_user_id?: number | null;
    created_at?: string | null;
    updated_at?: string | null;
    /** List of guideline objects */
    guidelines?: Guideline[];
    /** Null means never checked, which is not the same as an empty list. */
    conflicts?: PlaybookConflict[] | null;
};
export type CreatePlaybookRequestData = {
    type?: string;
    attributes: Playbook;
};
export type CreatePlaybookRequest = {
    data: CreatePlaybookRequestData;
};
export type GuidelineSummary = {
    uuid: string;
    name: string;
    risk?: RiskLevel | null;
};
export type PlaybookSummary = {
    name?: string;
    description?: string;
    restrictions?: PlaybookRestrictions | null;
    status?: PlaybookStatus;
    created_by_pilot_user_id?: number | null;
    updated_by_pilot_user_id?: number | null;
    created_at?: string | null;
    updated_at?: string | null;
    uuid: string;
    guidelines?: GuidelineSummary[];
};
export type PlaybookSummaryResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookSummary;
};
export type PlaybookPageMeta = {
    offset: number;
    limit: number;
    count: number;
    total: number;
    search?: string | null;
};
export type ListPlaybooksResponse = {
    data: PlaybookSummaryResponseData[];
    meta: PlaybookPageMeta;
    links: PageLinks;
};
export type PlaybookTemplateSummary = {
    id: string;
    name: string;
    short_description: string;
};
export type PlaybookTemplateSummaryResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookTemplateSummary;
};
export type ListPlaybookTemplatesResponse = {
    data: PlaybookTemplateSummaryResponseData[];
};
export type Guideline2 = {
    /** UUID for referencing existing guideline or preset UUID for new guideline */
    id?: string | null;
    name: string;
    /** Rich text string for guideline text */
    guideline?: string;
    /** Rich text string for sample language */
    sample?: string;
    variations?: GuidelineClauseVariation[];
    suggest_redlines?: boolean;
    /** Admin-configured risk level override. When unset, AI determines risk at runtime. */
    risk?: RiskLevel | null;
    /** AI-generated provenance for this guideline. Static — captured at generation time and not updated when the guideline is edited. Excluded from playbook exports. */
    citations?: Citation[] | null;
    /** Null means never extracted, which is not the same as an empty list. */
    rules?: GuidelineRule[] | null;
    created_at?: string | null;
    updated_at?: string | null;
    /** ID of the user who created this guideline. */
    created_by_pilot_user_id?: number | null;
    /** ID of the user who last updated this guideline. */
    updated_by_pilot_user_id?: number | null;
};
export type PlaybookTemplate = {
    id: string;
    name: string;
    short_description: string;
    description: string;
    guidelines: Guideline2[];
};
export type PlaybookTemplateResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookTemplate;
};
export type GetPlaybookTemplateResponse = {
    data: PlaybookTemplateResponseData;
};
export type PlaybookSummaryAnalytics = {
    total_completed_reviews_count?: number;
    last_run_at?: string | null;
};
export type PlaybookSummaryWithAnalytics = {
    name?: string;
    description?: string;
    restrictions?: PlaybookRestrictions | null;
    status?: PlaybookStatus;
    created_by_pilot_user_id?: number | null;
    updated_by_pilot_user_id?: number | null;
    created_at?: string | null;
    updated_at?: string | null;
    uuid: string;
    guidelines?: GuidelineSummary[];
    analytics: PlaybookSummaryAnalytics;
    can_use?: boolean | null;
    can_edit?: boolean | null;
    is_restricted?: boolean | null;
};
export type PlaybookSummaryWithAnalyticsResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookSummaryWithAnalytics;
};
export type PlaybookRestrictionType = "none" | "accessible" | "restricted";
export type ListPlaybooksFilters = {
    name?: string | null;
    last_modified?: PlaybookLastModifiedBucket | null;
    status?: PlaybookStatus | null;
    workflow_id?: string | null;
    /** Narrow results to playbooks where the caller holds at least this access tier. Applied after ACL annotation, so it is a no-op when `Flag.PLAYBOOK_ACL` is off. */
    access?: PlaybookAccessLevel | null;
    /** Narrow results to playbooks in any of these restriction states. Applied after ACL annotation, so it is a no-op when `Flag.PLAYBOOK_ACL` is off. */
    restriction?: PlaybookRestrictionType[] | null;
};
export type PlaybookListField = "name" | "status" | "guidelines" | "created_by_pilot_user_id" | "updated_by_pilot_user_id" | "created_at" | "updated_at" | "analytics";
export type ListPlaybooksRequestAttributes = {
    filters?: ListPlaybooksFilters | null;
    /** None => return every field. A set => include only these fields. */
    fields?: PlaybookListField[] | null;
    sort?: string;
    page?: PageMeta;
    /** Only set when `access=` was applied: how many playbooks matched the other filters but were removed because the caller lacks that access. With `page.total` 0, a positive value means playbooks exist that the caller can't use. */
    excluded_by_access?: number | null;
};
export type ListPlaybooksWithAnalyticsResponse = {
    data: PlaybookSummaryWithAnalyticsResponseData[];
    meta: ListPlaybooksRequestAttributes;
};
export type ValidationStatus = "valid" | "error";
export type ValidationIssueCode = "NAME_CONFLICT" | "FIELD_INVALID" | "MAX_GUIDELINES_EXCEEDED";
export type ValidationIssue = {
    code: ValidationIssueCode;
    severity?: string;
    message: string;
    field_path: string;
    suggestion?: string | null;
};
export type ValidatedVariation = {
    id?: null;
    clause_variation_id?: string | null;
    name?: string | null;
    text?: string | null;
    position?: string | null;
    guidance?: string | null;
    validation_status: ValidationStatus;
    validation_issues: ValidationIssue[];
};
export type ValidatedGuideline = {
    id?: null;
    name?: string | null;
    guideline?: string | null;
    sample?: string | null;
    suggest_redlines?: boolean | null;
    risk?: string | null;
    validation_status: ValidationStatus;
    validation_issues: ValidationIssue[];
    variations: ValidatedVariation[];
};
export type ValidatedPlaybookAttributes = {
    name?: string | null;
    description?: string | null;
    restrictions?: {
        [key: string]: any;
    } | null;
    guidelines: ValidatedGuideline[];
    validation_status: ValidationStatus;
    validation_issues: ValidationIssue[];
};
export type ValidateImportPlaybookResponseData = {
    type?: string;
    id?: null;
    attributes: ValidatedPlaybookAttributes;
};
export type ValidateImportSummaryMeta = {
    total_guidelines: number;
    total_variations: number;
    errors: number;
    has_blocking_errors: boolean;
};
export type ValidateImportMeta = {
    summary: ValidateImportSummaryMeta;
};
export type ValidateImportPlaybookResponse = {
    data: ValidateImportPlaybookResponseData;
    meta: ValidateImportMeta;
};
export type ValidationSource = "import" | "ai_playbook";
export type ExportClauseVariation = {
    clause_variation_id?: string | null;
    name: string;
    text?: string | null;
    position: string;
    guidance?: string | null;
    order: number;
};
export type ExportGuideline = {
    id: string;
    name: string;
    guideline: string;
    sample: string;
    suggest_redlines: boolean;
    risk?: string | null;
    variations: ExportClauseVariation[];
};
export type ExportPlaybookData = {
    name: string;
    description: string;
    restrictions?: {
        [key: string]: any;
    } | null;
    guidelines: ExportGuideline[];
};
export type PlaybookExportData = {
    version?: string;
    schema_version?: string;
    exported_at: string;
    source_environment: string;
    playbook: ExportPlaybookData;
};
export type AiGeneratedVariation = {
    clause_variation_id?: string | null;
    name?: string | null;
    text?: string | null;
    position?: string | null;
    guidance?: string | null;
};
export type AiGeneratedGuideline = {
    name?: string | null;
    guideline?: string | null;
    sample?: string | null;
    suggest_redlines?: boolean | null;
    risk?: string | null;
    variations?: AiGeneratedVariation[];
};
export type AiGeneratedPlaybookData = {
    name?: string | null;
    description?: string | null;
    restrictions?: {
        [key: string]: any;
    } | null;
    guidelines?: AiGeneratedGuideline[];
};
export type ValidatePlaybookAttributes = {
    validation_source?: ValidationSource;
    auto_apply_suggestions?: boolean;
    import_data?: PlaybookExportData | null;
    playbook_data?: AiGeneratedPlaybookData | null;
};
export type ValidatePlaybookRequestData = {
    type?: string;
    attributes: ValidatePlaybookAttributes;
};
export type ValidatePlaybookRequest = {
    data: ValidatePlaybookRequestData;
};
export type ContractsReviewedRateSummary = {
    rate?: number | null;
    reviewed_with_playbooks_count?: number | null;
    participated_tickets_count?: number | null;
};
export type RedlineAcceptanceRateSummary = {
    rate?: number | null;
    accepted_redlines_count?: number | null;
    total_suggestions_count?: number | null;
    total_risky_suggestions_count?: number | null;
    accepted_risky_redlines_count?: number | null;
};
export type TicketUsageBucket = {
    total?: number | null;
    done?: number | null;
    in_progress?: number | null;
    inactive?: number | null;
    cancelled?: number | null;
};
export type PlaybookUsage = {
    contracts_reviewed_with_playbook_count: TicketUsageBucket;
    contracts_reviewed_without_playbook_count: TicketUsageBucket;
};
export type RedlineBreakdown = {
    acceptance_rate?: number | null;
    accepted_as_is_rate?: number | null;
    accepted_as_is_count?: number | null;
    accepted_with_mod_rate?: number | null;
    accepted_with_mod_count?: number | null;
    deferred_suggestions_rate?: number | null;
    deferred_suggestions_count?: number | null;
    rejected_suggestions_rate?: number | null;
    rejected_suggestions_count?: number | null;
};
export type RedlineTrendBucket = {
    total_suggestions_count?: number | null;
    accepted_as_is_redlines_count?: number | null;
    accepted_with_mod_redlines_count?: number | null;
    deferred_suggestions_count?: number | null;
    rejected_suggestions_count?: number | null;
    total_risky_suggestions_count?: number | null;
    accepted_risky_redlines_count?: number | null;
    start_date: string;
    end_date: string;
    redline_acceptance_rate?: number | null;
    accepted_as_is_redlines_rate?: number | null;
    accepted_with_mod_redlines_rate?: number | null;
    deferred_suggestions_rate?: number | null;
    rejected_suggestions_rate?: number | null;
};
export type RedlineMetrics = {
    breakdown: RedlineBreakdown;
    trends?: RedlineTrendBucket[];
};
export type PlaybookUsageAnalyticsAttributes = {
    contracts_reviewed_rate: ContractsReviewedRateSummary;
    redline_acceptance_rate: RedlineAcceptanceRateSummary;
    playbook_usage: PlaybookUsage;
    redline_metrics: RedlineMetrics;
};
export type PlaybookUsageAnalyticsResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookUsageAnalyticsAttributes;
};
export type TimeRangeFilters = {
    start_date: string;
    end_date: string;
};
export type PlaybookUsageAnalyticsRequestAttributes = {
    playbook_ids?: string[] | null;
    time_range: TimeRangeFilters;
};
export type PlaybookUsageAnalyticsResponse = {
    data: PlaybookUsageAnalyticsResponseData;
    meta: PlaybookUsageAnalyticsRequestAttributes;
};
export type PlaybookUsageAnalyticsRequestData = {
    type?: string;
    attributes: PlaybookUsageAnalyticsRequestAttributes;
};
export type PlaybookUsageAnalyticsRequest = {
    data: PlaybookUsageAnalyticsRequestData;
};
export type MostNegotiatedRequirement = {
    guideline_id: string;
    name: string;
    total_reviews_count?: number;
    flag_rate?: number | null;
};
export type RedlineReduction = {
    first_redlines_count: number;
    first_critical_redlines_count: number;
    latest_redlines_count: number;
    latest_critical_redlines_count: number;
};
export type PlaybookRecentUse = {
    ticket_id: string;
    name: string;
    last_activity_date: string;
    redline_reduction: RedlineReduction;
    turns_count: number;
    status: "done" | "cancelled" | "in_progress";
};
export type PlaybookDetailAnalyticsResponseAttributes = {
    most_negotiated_requirements?: MostNegotiatedRequirement[];
    recent_uses?: PlaybookRecentUse[];
};
export type PlaybookDetailAnalyticsResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookDetailAnalyticsResponseAttributes;
};
export type PlaybookDetailAnalyticsMeta = {
    most_negotiated_requirements: PageMeta;
};
export type PlaybookDetailAnalyticsResponse = {
    data: PlaybookDetailAnalyticsResponseData;
    meta: PlaybookDetailAnalyticsMeta;
};
export type GuidelineWithAcl = {
    /** UUID for referencing existing guideline or preset UUID for new guideline */
    id?: string | null;
    name: string;
    /** Rich text string for guideline text */
    guideline?: string;
    /** Rich text string for sample language */
    sample?: string;
    variations?: GuidelineClauseVariation[];
    suggest_redlines?: boolean;
    /** Admin-configured risk level override. When unset, AI determines risk at runtime. */
    risk?: RiskLevel | null;
    /** AI-generated provenance for this guideline. Static — captured at generation time and not updated when the guideline is edited. Excluded from playbook exports. */
    citations?: Citation[] | null;
    /** Null means never extracted, which is not the same as an empty list. */
    rules?: GuidelineRule[] | null;
    created_at?: string | null;
    updated_at?: string | null;
    /** ID of the user who created this guideline. */
    created_by_pilot_user_id?: number | null;
    /** ID of the user who last updated this guideline. */
    updated_by_pilot_user_id?: number | null;
    uuid: string;
    /** Whether this guideline is restricted, i.e. not open to the whole tenant. A guideline is open if any playbook containing it is open. Null unless requested via `guideline-acl=true`, and whenever Flag.PLAYBOOK_ACL is off or the check failed. */
    is_restricted?: boolean | null;
};
export type PlaybookWithAccess = {
    name?: string;
    description?: string;
    restrictions?: PlaybookRestrictions | null;
    status?: PlaybookStatus;
    created_by_pilot_user_id?: number | null;
    updated_by_pilot_user_id?: number | null;
    created_at?: string | null;
    updated_at?: string | null;
    uuid: string;
    guidelines?: GuidelineWithAcl[];
    /** Null means never checked, which is not the same as an empty list. */
    conflicts?: PlaybookConflict[] | null;
    can_edit?: boolean | null;
};
export type GetPlaybookResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookWithAccess;
};
export type GetPlaybookMeta = {
    clause_acl?: ClauseAclStatus | null;
    guideline_acl?: ClauseAclStatus | null;
};
export type GetPlaybookResponse = {
    data: GetPlaybookResponseData;
    meta?: GetPlaybookMeta | null;
};
export type UpdatePlaybookResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookWithId;
};
export type UpdatePlaybookResponse = {
    data: UpdatePlaybookResponseData;
};
export type UpdatePlaybookRequestData = {
    type?: string;
    attributes: Playbook;
};
export type UpdatePlaybookRequest = {
    data: UpdatePlaybookRequestData;
};
export type ExportPlaybookData2 = {
    name: string;
    description: string;
    restrictions?: {
        [key: string]: any;
    } | null;
    guidelines: ExportGuideline[];
};
export type PlaybookExportData2 = {
    version?: string;
    schema_version?: string;
    exported_at: string;
    source_environment: string;
    playbook: ExportPlaybookData2;
};
export type ExportPlaybookResponseData = {
    type?: string;
    id: string;
    attributes: PlaybookExportData2;
};
export type ExportPlaybookResponse = {
    data: ExportPlaybookResponseData;
};
export type PlaybookAccessPrincipalType = "user" | "department";
export type PlaybookAccessGrant = {
    type: PlaybookAccessPrincipalType;
    id: string;
    level: PlaybookAccessLevel;
    name?: string | null;
};
export type PlaybookAccessAttributes = {
    everyone?: PlaybookAccessLevel | null;
    grants?: PlaybookAccessGrant[];
};
export type SetPlaybookAccessResponse = {
    everyone?: PlaybookAccessLevel | null;
    grants?: PlaybookAccessGrant[];
    consistency_token?: string | null;
};
export type PlaybookAccessAttributes2 = {
    everyone?: PlaybookAccessLevel | null;
    grants?: PlaybookAccessGrant[];
};
